import React from "react"
import { Button } from "@mantine/core"
import { useFormContext } from "react-hook-form"
import { useNavigate } from "react-router-dom"

import { Icon, PageFooter } from "@/components"
import { useStyles } from "@/components/QuorumFormProvider/Footer/Footer.styles"

type FooterProps = {
    cancelLabel?: string
    cancelDisabled?: boolean
    submitLabel?: string
    submitDisabled?: boolean
}

export const Footer = ({
    cancelLabel = "Cancel",
    cancelDisabled = false,
    submitLabel = "Done",
    submitDisabled = false,
}: FooterProps) => {
    // We need to destructure here to read `isSubmitting` before rendering,
    // so that react hook form knows we care about it, and will re-render the component when it changes.
    const {
        formState: { isSubmitting },
    } = useFormContext()
    const navigate = useNavigate()

    const { classes } = useStyles()

    return (
        <PageFooter>
            <Button
                className={classes.button}
                variant="outline"
                leftIcon={<Icon icon="times" />}
                onClick={() => navigate(-1)}
                disabled={cancelDisabled}
            >
                {cancelLabel}
            </Button>
            <Button
                className={classes.button}
                data-plum-id="button-submit"
                type="submit"
                loading={isSubmitting}
                leftIcon={<Icon icon="check" />}
                disabled={submitDisabled}
            >
                {submitLabel}
            </Button>
        </PageFooter>
    )
}
